import styled from 'styled-components';
import {media, theme, tokens} from "../../../theme";

export const AttachmentOuterWrapper = styled.div`
    width: 100%;
    order: -1;
    margin-bottom: 8px;
    gap: 4px;
    display: flex;
    flex-direction: column;
`;

export const FileInfoContainer = styled.div`
    display: inline-flex;
    align-items: center;
    background-color: ${({theme}) => theme.palette.background.element};
    color: ${({theme}) => theme.palette.text.primary};
    border-radius: ${tokens.radius.lg};
    padding: 6px 12px;
    gap: 8px;
    width: 100%;
    min-width: 40px;
    border: 1px solid ${({theme}) => theme.palette.divider};
    box-sizing: border-box;

    ${media.smPlus} {
        max-width: 80%;
    }
`;

export const FileIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.palette.primary.main};
    padding: 6px;
    border-radius: 8px;

    svg {
        path {
            stroke: white;
        }

        width: 24px;
        height: 24px;
    }
`;

export const FileTextInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    overflow: hidden;
    flex: 1;
`;

export const FileName = styled.span`
    flex: 1;
    min-width: 40px;
    width: 100%;
    font-size: ${({theme}) => theme.typography.body2.fontSize};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    ${media.smPlus} {
        font-size: ${({theme}) => theme.typography.body2.fontSize};
    }
`;

export const FileExtension = styled.span`
    font-size: ${({theme}) => theme.typography.caption.fontSize};
    text-transform: uppercase;
    margin-left: 4px;
    opacity: 0.8;
`;

export const CollectionsList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FileInfoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px 12px;
    width: max-content;
    margin-top: 10px;
    gap: 8px;
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: ${({theme}) => theme.typography.body1.fontSize};
    color: ${({theme}) => theme.palette.text.secondary};
    padding: 0 4px;
    line-height: 1;
    margin-left: auto;
    
    &::after {
        content: '✕';
        font-weight: ${tokens.fontWeight.semibold};
    }
`;

